export const programs = {
    campus: 'Campus',
    utility: 'Utility',
    transit: 'Transit'
}
